import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
  Code, Briefcase, GraduationCap, Globe, Phone, Mail, 
  ExternalLink, Linkedin, ChevronRight 
} from 'lucide-react';

export default function About() {
  return (
    <div className="min-h-screen py-12 px-4" data-testid="about-page">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-primary to-secondary mx-auto mb-6 flex items-center justify-center">
            <Code className="w-12 h-12 text-white" />
          </div>
          <h1 className="text-4xl font-bold font-serif mb-4">À propos du développeur</h1>
          <p className="text-xl text-muted-foreground">Djibson Consulting</p>
        </div>

        {/* Profile Card */}
        <Card className="mb-8">
          <CardContent className="p-8">
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
                  <GraduationCap className="w-6 h-6 text-primary" />
                  Parcours
                </h2>
                <div className="space-y-4 text-muted-foreground">
                  <div className="flex items-start gap-3">
                    <ChevronRight className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                    <p><strong>Ingénieur en Informatique</strong> - Formation solide en développement logiciel et architecture des systèmes</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <ChevronRight className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                    <p><strong>Développeur Full-Stack</strong> - Expertise en technologies web modernes (React, Node.js, Python, bases de données)</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <ChevronRight className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                    <p><strong>Business Analyst</strong> - Analyse des besoins métier et conception de solutions adaptées</p>
                  </div>
                  <div className="flex items-start gap-3">
                    <ChevronRight className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                    <p><strong>Consultant indépendant</strong> - Accompagnement des entreprises dans leur transformation digitale</p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4 flex items-center gap-2">
                  <Briefcase className="w-6 h-6 text-primary" />
                  Services
                </h2>
                <ul className="space-y-3 text-muted-foreground">
                  <li className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                    Développement d'applications web sur mesure
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                    Conception et refonte de sites internet
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                    Conseil en stratégie digitale
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                    Analyse fonctionnelle et technique
                  </li>
                  <li className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                    Formation et accompagnement
                  </li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Contact Info */}
        <Card>
          <CardContent className="p-8">
            <h2 className="text-2xl font-bold mb-6 text-center">Me contacter</h2>
            <div className="grid sm:grid-cols-3 gap-6">
              <a 
                href="https://djibson-consulting.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex flex-col items-center p-4 rounded-xl bg-muted/50 hover:bg-muted transition-colors"
              >
                <Globe className="w-8 h-8 text-primary mb-2" />
                <span className="font-medium">Site Web</span>
                <span className="text-sm text-muted-foreground">djibson-consulting.com</span>
              </a>
              
              <a 
                href="tel:+33619446736"
                className="flex flex-col items-center p-4 rounded-xl bg-muted/50 hover:bg-muted transition-colors"
              >
                <Phone className="w-8 h-8 text-primary mb-2" />
                <span className="font-medium">Téléphone</span>
                <span className="text-sm text-muted-foreground">+33 6 19 44 67 36</span>
              </a>
              
              <a 
                href="mailto:contact@djibson-consulting.com"
                className="flex flex-col items-center p-4 rounded-xl bg-muted/50 hover:bg-muted transition-colors"
              >
                <Mail className="w-8 h-8 text-primary mb-2" />
                <span className="font-medium">Email</span>
                <span className="text-sm text-muted-foreground">contact@djibson-consulting.com</span>
              </a>
            </div>

            <div className="mt-8 text-center">
              <Button asChild size="lg" className="btn-pill">
                <a href="https://djibson-consulting.com" target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="w-4 h-4 mr-2" />
                  Visiter mon site
                </a>
              </Button>
            </div>
          </CardContent>
        </Card>

        {/* Footer note */}
        <p className="text-center text-muted-foreground mt-8">
          JAMM IMMOBILIER - Application développée par Djibson Consulting
        </p>
      </div>
    </div>
  );
}
